import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Nav() {
  const location = useLocation();
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const closeMenu = () => {
    setIsOpen(false);
  };

  return (
    <nav className="bg-gray-800 fixed top-0 left-0 right-0 z-50">
      <div className="container mx-auto flex justify-between items-center py-4 px-4 md:px-8">
        <Link className="text-white text-lg font-bold md:text-2xl whitespace-nowrap" to="#">PERSPECTIVE CONGO</Link>
        
        {/* Bouton hamburger */}
        <button
          className="text-white md:hidden focus:outline-none"
          aria-controls="navbarNav"
          aria-expanded={isOpen}
          aria-label="Toggle navigation"
          onClick={toggleMenu}
        >
          <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16m-7 6h7"></path>
          </svg>
        </button>

        {/* Menu */}
        <div className={`fixed top-0 left-0 w-full h-full bg-gray-900 bg-opacity-95 md:bg-transparent md:relative md:flex md:items-center md:justify-end transition-transform transform ${isOpen ? 'translate-x-0' : 'translate-x-full'} md:translate-x-0`} id="navbarNav">
          <button
            className="absolute top-4 right-4 text-white md:hidden"
            onClick={closeMenu}
            aria-label="Fermer le menu"
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12"></path>
            </svg>
          </button>
          <ul className="flex flex-col items-center justify-center h-full space-y-6 md:space-y-0 md:flex-row md:space-x-6">
            {['/', '/Apropos', '/Evenement', '/Galerie', '/Contact'].map((path, index) => {
              const labels = ['Accueil', 'À propos', 'Évènements', 'Galerie', 'Contact'];
              return (
                <li key={index}>
                  <Link 
                    className={`text-white text-lg md:text-base hover:text-yellow-500 ${location.pathname === path ? 'border-b-2 border-yellow-500' : ''}`} 
                    to={path}
                    onClick={closeMenu}
                  >
                    {labels[index]}
                  </Link>
                </li>
              );
            })}
          </ul>
        </div>
      </div>
    </nav>
  );
}
